import React from 'react';
import Logo from 'branding/logo';
const HomeLogo = ({ homePath, inverted }) => {
    const styles = {
        marginRight: '42px',
        width: '68px',
        height: '20px'
    };
    return homePath ? (React.createElement("a", { href: homePath, style: styles },
        React.createElement(Logo, { width: "68", height: "20", variant: inverted ? 'light' : 'dark' }))) : (React.createElement("div", { style: styles },
        React.createElement(Logo, { width: "68", height: "20", variant: inverted ? 'light' : 'dark' })));
};
export default HomeLogo;
//# sourceMappingURL=HomeLogo.js.map